import { CrossAccountConfigItemIcon, IsolatedAccountConfigItemIcon } from '@App/static/icons/MarginTransferModalIcons'

import { CONFIG_ITEMS } from './enums'

export const configOptions = [
  {
    id: CONFIG_ITEMS.CROSS,
    title: 'Cross Account',
    image: <CrossAccountConfigItemIcon />,
  },
  {
    id: CONFIG_ITEMS.ISOLATED,
    title: 'Isolated Account',
    image: <IsolatedAccountConfigItemIcon />,
  },
]
